/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles'
import QRCode from 'qrcode.react'
import * as actions from '../../actions/download';
import Link from '../../components/common/Link'
import s from './Download.css'
import logoImg from './logo.png'
import sloganImg from './slogan.png'
import { QUALIFICATION } from '../../constants'
import { APP_DOWNLOAD_WAP } from '../../config'
import '../../core/objectFitPolyfillBasic'

class Download extends React.Component {
  static propTypes = {
    download: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props)
    this.state = { search: '' }
  }

  componentDidMount() {
    this.setState({
      search: window.location.search,
    })
  }

  render() {
    const { download = {} } = this.props
    const { search } = this.state
    const renderLinks = data => data.map((link, inx) => <a key={`ft-link-${inx}`} href={link.url} target="_blank" rel="noopener noreferrer">{link.name}&nbsp;</a>)
    return (
      <div className={s.container}>
        {/* SEO 优化，不展示在页面中 */}
        <h1 className={s.title}>有道精品课-APP下载 - 为你精选好课</h1>
        <div className={s.videoBg}>
          {
            // eslint-disable-next-line jsx-a11y/media-has-caption
            <video
              muted
              loop="loop"
              data-object-fit
              autoPlay="autoplay"
              className={s.video}
            >
              <source src="https://ydschool-video.nosdn.127.net/1594626094731downloadVideo.mp4" />
              抱歉，您的浏览器不支持内嵌视频
            </video>
          }
        </div>
        <div className={s.content}>
          <div className={s.header}>
            <img className={s.logo} src={logoImg} alt="有道精品课" />
            <Link to="/" title="有道精品课">访问首页</Link>
            <a
              href={download.download}
              title="有道精品课-小班课PC端下载"
            >小班课PC端下载</a>
          </div>
          <div className={s.middle}>
            <img className={s.slogan} src={sloganImg} alt="有道精品课，老师就是好！" />
            <div>
              <div className={s.qr}>
                <QRCode
                  className={s.qrcode}
                  size={170}
                  renderAs="svg"
                  value={`${APP_DOWNLOAD_WAP}${search}`}
                />
              </div>
              <div className={s.tips}>扫码下载App</div>
            </div>
          </div>
          <div className={s.footer}>
            ©{new Date().getFullYear()}&nbsp;
            {renderLinks(QUALIFICATION)} 京ICP证080268号 京公网安备
            11010802020092号
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    download: state.download,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(s)(Download))



// WEBPACK FOOTER //
// ./src/routes/download/Download.js